module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/flat-lays/flat-lay-03-3f23ccaffc0b354477de28b3fcf90bf8.jpg";